/**
 * options.js contains lists of options/enum values that are used throughout the application.
 */

export const statusOptions = [
  { value: 'active', label: 'Active' },
  { value: 'new', label: 'New' },
  { value: 'suspended', label: 'Suspended' },
];

export default {
  statusOptions,
};
